import { RootState } from "../../app";

const selectActiveDocument = (state: RootState) =>
  state.documentReducer.activeDocument;

export default selectActiveDocument;
